export default {
  methods: {
    getPreviewWidth(width) {
      if (this.previewSizes) {
        let previewWidth = this.previewSizes[0];
        for (let i = 1; i < this.previewSizes.length; i++) {
          if (previewWidth < width) {
            previewWidth = this.previewSizes[i];
          } else {
            break;
          }
        }
        return previewWidth;
      }
    },
    serialiseAsset(data) {
      const {
        name,
        tags,
        description,
        published,
        changelog,
        content_type: contentType,
        monetized_actions: monetizedActions,
        screenshots,
        protected: _protected,
        thumbnail,
        metadata,
        released_at: releasedAt,
        updated_at: updatedAt,
        hidden,
        videos,
        asset_guid: assetGuid,
        verified_author: verifiedAuthor,
        revision,
        user_id: userId,
        subscribers_count: subscribersCount,
        id,
      } = data;

      const updatedAsset = {
        name,
        tags,
        contentType,
        published,
        userId,
        monetizedActions,
        description,
        changelog,
        releasedAt,
        metadata,
        hidden,
        updatedAt,
        media: [...(screenshots || []), ...(videos || [])],
        mediaToDelete: [],
        protected: _protected,
        assetGuid,
        thumbnail,
        revision,
        subscribersCount,
        verifiedAuthor,
        id,
      };

      if (!this.tmpAsset.mediaToDelete) {
        updatedAsset.mediaToDelete = [];
      }
      this.isNextActive = true;
      if (!this.tmpAsset.id) {
        this.$emit('change', this.tmpAsset.id); //TODO: check if it is needed 👀
      } else {
        this.hidden = data.hidden;
      }
      return updatedAsset;
    },
  },
};
